export enum ESpecialRegistrationSchemeType {
	IOSS = 'IOSS',
	UNION = 'UNION',
	NON_UNION = 'NON-UNION',
	NON_EU = 'NON-EU',
}

export enum EEmEnums {
	SITE_INTEGRATION_TYPE = 'site_integration_type',
	SITE_PLATFORM = 'em_platform',
	FEES_CLASS = 'fee_class',
	ANNUAL_FEE_TYPE_ID = 'em_annual_fee_type',
	INVOICE_FEE_TYPE_ID = 'em_invoicing_fee_type',
	TIMEZONE_LIST = 'timezone_list',
	WEIGHT_UNIT = 'weight_unit',
	CUSTOMS_DATA_STATUS = 'customs_data_status',
	PAYMENT_MODE = 'payment_mode',
	IOSS_SALE_OVER_THRESHOLD_OPTION = 'ioss_sale_over_threshold_option',
	IOSS_DUTY_MODES = 'ioss_duty_mode',
	SUPPORTED_CURRENCY = 'supported_currency',
	CURRENCY_CODE = 'currency_code',
	LEGAL_STATUS_EU = 'legal_status_eu',
	EUDR_SUBSCRIPTION_PLAN = 'eudr_subscription_plan',
	EM_REPORTING_FEE_ACTUAL = 'em_reporting_fee_actual',
	MANUAL_FEE_CLASS = 'manual_fee_class',
	MONTHLY_FEES = 'monthly_fees',
	SERVICE_TYPE = 'service_type',
	EMAIL_TYPE = 'email_type',
	SMS_TYPE = 'sms_type',
}
export const FEES_CLASSES = 'fee_classes';
export const REPORTING_FEE_TYPE_ID = 'reporting_fee_type';

export enum EEmSiteIntegrationType {
	CSV = 'CSV',
	API = 'api',
	PLUGIN = 'plugin',
}

export enum EEmSitePlatform {
	BIGCOMMERCE = 'bigcommerce',
	SHOPIFY = 'shopify',
	WOOCOMMERCE = 'woocommerce',
	WIX = 'wix',
	MAGENTO = 'magento',
	ZENCARD = 'zencart',
	SQUARESPACE = 'SquareSpace',
	SHOPWARE5 = 'Shopware 5',
	SHOPWARE6 = 'Shopware 6',
	SHOPLAZZA = 'Shoplazza',
	OPENCART = 'opencart',
	PRESTASHOP = 'PrestaShop',
	OTHER = 'other',
	SQUARE = 'square',
}

export const EmSitePlatformImages = {
	[EEmSitePlatform.SHOPIFY]: '/img/platformLogoSvg/shopify.svg',
	[EEmSitePlatform.WOOCOMMERCE]: '/img/platformLogoSvg/wordpress.svg',
	[EEmSitePlatform.WIX]: '/img/platformLogoSvg/wix.svg',
	[EEmSitePlatform.ZENCARD]: '/img/platformLogoSvg/zenCard.svg',
	[EEmSitePlatform.SQUARESPACE]: '/img/platformLogoSvg/squareSpace.svg',
	none: '/img/platformLogo/none.png',
	[EEmSitePlatform.SHOPWARE5]: '/img/platformLogoSvg/shopware.svg',
	[EEmSitePlatform.SHOPWARE6]: '/img/platformLogoSvg/shopware.svg',
	[EEmSitePlatform.SHOPLAZZA]: '/img/platformLogoSvg/shoplazza.svg',
	[EEmSitePlatform.OPENCART]: '/img/platformLogoSvg/opencart.svg',
	[EEmSitePlatform.PRESTASHOP]: '/img/platformLogoSvg/prestashop.svg',
	[EEmSitePlatform.MAGENTO]: '/img/platformLogoSvg/magento.svg',
	[EEmSitePlatform.BIGCOMMERCE]: '/img/platformLogoSvg/bigcommerce.svg',
	[EEmSitePlatform.SQUARE]: '/img/platformLogoSvg/squareSpace.svg',
};
